/* Clarion Camping — living campfire.
   A canvas flame, ember and light-flicker layer over a still photograph, so a
   photo of people round a fire behaves like a short loop of video. The fire
   leans toward the pointer and flares when you move near it; tapping throws a
   burst of sparks. Fully skipped under prefers-reduced-motion and paused
   whenever the section is off screen. */
(function () {
  function init(canvas) {
    if (!canvas || canvas.dataset.ccReady === '1') return;
    canvas.dataset.ccReady = '1';

    var host = canvas.closest('[data-cc-section="firepit"]') || canvas.parentElement;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0;
    var hx = 0, hy = 0;              /* hearth position in px */
    var flames = [], embers = [], sparks = [];
    var pointer = { x: -9999, y: -9999, near: 0 };
    var running = false, rafId = null, t = 0;

    var hotX = parseFloat(canvas.dataset.hotX || '50') / 100;
    var hotY = parseFloat(canvas.dataset.hotY || '72') / 100;
    var power = parseFloat(canvas.dataset.intensity || '100') / 100;

    function sprite(r, g, b) {
      var s = 64;
      var off = document.createElement('canvas');
      off.width = off.height = s;
      var c = off.getContext('2d');
      var grad = c.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
      grad.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',1)');
      grad.addColorStop(0.35, 'rgba(' + r + ',' + g + ',' + b + ',0.45)');
      grad.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
      c.fillStyle = grad;
      c.fillRect(0, 0, s, s);
      return off;
    }

    var hot = sprite(255, 236, 170);
    var mid = sprite(255, 150, 48);
    var cool = sprite(196, 58, 12);
    var glow = sprite(255, 146, 60);

    function rand(a, b) { return a + Math.random() * (b - a); }

    function resize() {
      var rect = canvas.getBoundingClientRect();
      var cw = rect.width || host.offsetWidth;
      var ch = rect.height || host.offsetHeight;
      if (!cw || !ch) return false;
      if (Math.abs(cw - w) < 2 && Math.abs(ch - h) < 2) return true;
      w = cw; h = ch;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      hx = w * hotX;
      hy = h * hotY;
      flames = []; embers = []; sparks = [];
      return true;
    }

    function newFlame() {
      var spread = w * 0.028;
      return {
        x: hx + rand(-spread, spread),
        y: hy + rand(-3, 6),
        vx: rand(-0.22, 0.22),
        vy: rand(-1.5, -0.65),
        life: 1,
        decay: rand(0.014, 0.032),
        size: rand(w * 0.018, w * 0.05)
      };
    }

    function newEmber() {
      return {
        x: hx + rand(-w * 0.03, w * 0.03),
        y: hy + rand(-6, 4),
        vx: rand(-0.3, 0.3),
        vy: rand(-1.4, -0.5),
        life: 1,
        decay: rand(0.0035, 0.009),
        size: rand(1.4, 3.4)
      };
    }

    function burst(x, y) {
      for (var i = 0; i < 26; i++) {
        var a = rand(-Math.PI, 0);
        var sp = rand(0.8, 3.4);
        sparks.push({
          x: x, y: y,
          vx: Math.cos(a) * sp,
          vy: Math.sin(a) * sp - 0.6,
          life: 1,
          decay: rand(0.012, 0.03),
          size: rand(1.2, 2.8)
        });
      }
    }

    function draw() {
      rafId = null;
      if (!running) return;
      t++;

      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';

      /* Pointer proximity stokes the fire. */
      var dx = pointer.x - hx, dy = pointer.y - hy;
      var dist = Math.sqrt(dx * dx + dy * dy);
      var want = dist < w * 0.45 ? 1 - dist / (w * 0.45) : 0;
      pointer.near += (want - pointer.near) * 0.06;

      var breath = 0.82 + 0.18 * Math.sin(t * 0.045) + 0.08 * Math.sin(t * 0.17);
      var intensity = power * breath * (1 + pointer.near * 0.75);

      /* Ambient light wash on the scene. */
      var gs = w * (0.5 + 0.05 * Math.sin(t * 0.06)) * (1 + pointer.near * 0.2);
      ctx.globalAlpha = 0.2 * intensity;
      ctx.drawImage(glow, hx - gs / 2, hy - gs / 2, gs, gs);

      var i, p, s;

      var flameTarget = Math.round(26 * intensity);
      while (flames.length < flameTarget) flames.push(newFlame());
      for (i = flames.length - 1; i >= 0; i--) {
        p = flames[i];
        p.vy -= 0.012;
        p.vx += Math.sin((t + i * 30) * 0.05) * 0.02 + pointer.near * (dx > 0 ? 0.012 : -0.012);
        p.x += p.vx;
        p.y += p.vy;
        p.life -= p.decay;
        if (p.life <= 0) { flames.splice(i, 1); continue; }
        var img = p.life > 0.66 ? hot : (p.life > 0.33 ? mid : cool);
        var sz = p.size * (0.5 + p.life * 0.9);
        ctx.globalAlpha = Math.min(1, p.life * 0.9) * 0.75;
        ctx.drawImage(img, p.x - sz / 2, p.y - sz / 2, sz, sz);
      }

      if (t % 3 === 0 && embers.length < 40 * intensity) embers.push(newEmber());
      for (i = embers.length - 1; i >= 0; i--) {
        p = embers[i];
        p.vy -= 0.004;
        p.x += p.vx + Math.sin((t + i * 55) * 0.02) * 0.28;
        p.y += p.vy;
        p.life -= p.decay;
        if (p.life <= 0 || p.y < -20) { embers.splice(i, 1); continue; }
        var es = p.size * 9;
        ctx.globalAlpha = p.life * 0.6 * (0.6 + 0.4 * Math.sin((t + i * 13) * 0.2));
        ctx.drawImage(mid, p.x - es / 2, p.y - es / 2, es, es);
      }

      for (i = sparks.length - 1; i >= 0; i--) {
        s = sparks[i];
        s.vy += 0.035;
        s.x += s.vx;
        s.y += s.vy;
        s.life -= s.decay;
        if (s.life <= 0) { sparks.splice(i, 1); continue; }
        var ss = s.size * 8;
        ctx.globalAlpha = s.life * 0.85;
        ctx.drawImage(hot, s.x - ss / 2, s.y - ss / 2, ss, ss);
      }

      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
      rafId = window.requestAnimationFrame(draw);
    }

    function start() {
      if (running) return;
      if (!w || !h) { if (!resize()) return; }
      running = true;
      if (!rafId) rafId = window.requestAnimationFrame(draw);
    }

    function stop() {
      running = false;
      if (rafId) { window.cancelAnimationFrame(rafId); rafId = null; }
    }

    host.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect();
      pointer.x = e.clientX - r.left;
      pointer.y = e.clientY - r.top;
    });
    host.addEventListener('pointerleave', function () {
      pointer.x = pointer.y = -9999;
    });
    host.addEventListener('pointerdown', function (e) {
      var r = canvas.getBoundingClientRect();
      burst(e.clientX - r.left, e.clientY - r.top);
    });

    if ('ResizeObserver' in window) new ResizeObserver(function () { resize(); }).observe(host);
    window.addEventListener('resize', function () {
      window.clearTimeout(canvas._ccRT);
      canvas._ccRT = window.setTimeout(resize, 160);
    });
    window.addEventListener('load', resize);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) start(); else stop(); });
      }, { threshold: 0.05 }).observe(canvas);
    }

    resize();
    start();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-cc-firepit]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();